declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_spread_keep1_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_spread_keep1 extends $bog_fragile_demo_spread_base1 {
		Extra( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=keep1.view.tree.d.ts.map